import Vue from "vue";
import Vuex from "vuex";

import detail from "./detail";
import browse from "./browse";
import content from "./content";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    browse,
    detail,
    content,
  },
  strict: process.env.NODE_ENV !== "production",
  // plugins: debug ? [createLogger()] : []
});
